/**
 * HUB-G — Onglet Vue d'ensemble (timeline unifiée).
 */
import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import useActiviteTimeline from '../../../hooks/activite/useActiviteTimeline';
import ActiviteOverviewAccessBanner from '../ActiviteOverviewAccessBanner';
import ActiviteTimelineKpiStrip from '../ActiviteTimelineKpiStrip';
import ActiviteTimelineTypeFilters from '../ActiviteTimelineTypeFilters';
import ActiviteTimeline from '../ActiviteTimeline';
import {
  ACTIVITE_TAB_IDS,
  ACTIVITE_TIMELINE_OVERVIEW_LIMIT,
} from '../../../utils/activite/activityTabs';

export default function ActiviteOverviewTab({ filters }) {
  const { api, isAdmin } = useAuth();
  const {
    events,
    kpis,
    loading,
    error,
    typeFilter,
    setTypeFilter,
  } = useActiviteTimeline(api, filters, { enabled: true, isAdmin });

  return (
    <div
      className="rounded-xl border p-4 sm:p-5 space-y-4"
      style={{ background: 'var(--rm-bg-elevated)', borderColor: 'var(--rm-border-subtle)' }}
      data-testid="activite-overview-tab"
    >
      <ActiviteOverviewAccessBanner />

      <ActiviteTimelineKpiStrip
        kpis={kpis}
        magasinId={filters.magasin_id}
        eventCount={events.length}
      />

      <ActiviteTimelineTypeFilters value={typeFilter} onChange={setTypeFilter} />

      {error && (
        <div
          className="rounded-xl border p-4 text-sm text-[var(--rm-red-light)]"
          style={{ borderColor: 'var(--rm-border-strong)', background: 'var(--rm-red-muted)' }}
          data-testid="activite-timeline-error"
        >
          {error}
        </div>
      )}

      <ActiviteTimeline events={events} loading={loading} />

      <span className="sr-only" data-testid="activite-timeline-overview-limit">
        {ACTIVITE_TIMELINE_OVERVIEW_LIMIT}
      </span>
      <span className="sr-only" data-testid="activite-overview-tab-id">{ACTIVITE_TAB_IDS.OVERVIEW}</span>
    </div>
  );
}
